import { EXTENSIONS_MIME_TYPE_MAP, getMimeType } from '@ubnt/link-core-ui/components/Image';

export const getSingleImgSrc = (imgSrc: string | string[], supportsAvif: boolean, supportsWebp: boolean) => {
  if (typeof imgSrc === 'string') {
    return imgSrc;
  }

  const imageMap = imgSrc.reduce(
    (acc, url) => {
      const mimeType = getMimeType(url);
      if (mimeType) {
        acc[mimeType] = url;
      }
      return acc;
    },
    {} as Record<string, string>
  );

  if (supportsAvif && imageMap[EXTENSIONS_MIME_TYPE_MAP.avif]) {
    return imageMap[EXTENSIONS_MIME_TYPE_MAP.avif];
  }

  if (supportsWebp && imageMap[EXTENSIONS_MIME_TYPE_MAP.webp]) {
    return imageMap[EXTENSIONS_MIME_TYPE_MAP.webp];
  }

  return imageMap[EXTENSIONS_MIME_TYPE_MAP.png] ?? imgSrc[0];
};
